import React from "react";
import { Form } from "rsuite";

import { DEFAULT_PRT_KEY } from "const";
import Protocols from "components/Filters/Protocols";
import Text from "components/Form/Text";

import { formDialerModel } from "./TrunkFormRefactored.utils";
import { StyledButton, StyledFormStretched } from "./TrunkFormRefactored.styles";

const DialerFormSection = ({
    formRef,
    disabled,
    initialValues,
    defaultSPKey,
    moreOptionsFlag,
    setMoreOptionsFlag,
    showOnlyMoreOption = false
}) => {
    if (initialValues.ip == null) {
        delete initialValues.ip;
        delete initialValues.tprefix;
        delete initialValues.port;
        delete initialValues.prt_key;
    }

    return (
        <Form
            layout="inline"
            model={formDialerModel}
            ref={formRef}
            formDefaultValue={{ prt_key: DEFAULT_PRT_KEY, sp_key: defaultSPKey, port: "5060", tprefix: "", ...initialValues }}
            style={{ margin: "0px", width: "100%" }}
        >
            <StyledFormStretched>
                {!showOnlyMoreOption && <div className="column">
                    <Text name="ip" label="IP" disabled={disabled} labelWidth={65} />
                    <div className="protocol">
                        <Protocols style={{ width: "160px" }} />
                        <Text name="port" label="Port" disabled={disabled} style={{ width: "90px" }} />
                    </div>

                    <Text name="tprefix" label="Techprefix" disabled={disabled} labelWidth={65} />
                </div>}
                <div className="column">
                    <StyledButton
                        open
                        onClick={() => {
                            setMoreOptionsFlag(!moreOptionsFlag);
                        }}>
                        More options
                    </StyledButton>
                </div>
            </StyledFormStretched>
        </Form>
    );
};

export default DialerFormSection;
